import { render, staticRenderFns } from "./SpeciesShow.vue?vue&type=template&id=5d8c762e&scoped=true&"
import script from "./SpeciesShow.vue?vue&type=script&lang=js&"
export * from "./SpeciesShow.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesShow.vue?vue&type=style&index=0&id=5d8c762e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c762e",
  null
  
)

export default component.exports